<template>
  <div class="order-details">
    <!--顶部导航-->
    <Navbar
      title="订单详情"
      :isHandleBack="true"
      :isSpecialBack="true"
      @goBack="handleBack"
    />
    <!--内容区域-->
    <div class="content">
      <!--订单详情卡片-->
      <order-details-card />
      <!--订单详情账户-->
      <order-details-account />
      <!--订单详情还款计划-->
      <order-details-payment-plan
        :stepList="stepList"
        :currentStep="currentStep"
      />
    </div>
  </div>
</template>

<script>
import Navbar from "@/components/navbar/index.vue";
import orderDetailsCard from "@/components/orderDetails/orderDetailsCard.vue";
import orderDetailsAccount from "@/components/orderDetails/orderDetailsAccount.vue";
import orderDetailsPaymentPlan from "@/components/orderDetails/orderDetailsPaymentPlan.vue";
import { getOnroadBorrowOrderDetail } from "@/api/index.js";

export default {
  name: "orderDetails",
  components: {
    Navbar,
    orderDetailsCard,
    orderDetailsAccount,
    orderDetailsPaymentPlan,
  },
  data() {
    return {
      stepList: [],
      currentStep: 1,
      routerFlag: "1",
      isNavigatingAway: false,
    };
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      if (from.name != "agreement") {
        vm.routerFlag = "2";
        vm.isNavigatingAway = false;
      } else {
        vm.routerFlag = "1";
      }
    });
  },
  async activated() {
    if (this.routerFlag == "2") {
      const borrowOrderId = this.$route.query.borrowOrderId;
      const res = await getOnroadBorrowOrderDetail(borrowOrderId);
      if (res.code === 2000) {
        this.$store.commit("setOrderDetails", res.data);
        sessionStorage.setItem("orderAgreement", JSON.stringify(res.data.agreement));
        this.stepList = [
          {
            title: "提交申请",
            desc: res.data.createTime ? res.data.createTime : "进行中",
          },
          {
            title: "资质审查",
            desc: res.data.reviewRiskTime
              ? res.data.reviewRiskTime
              : res.data.createTime
              ? "进行中"
              : "",
          },
          {
            title: "银行代发",
            desc: res.data.lendingTime
              ? res.data.lendingTime
              : res.data.reviewRiskTime
              ? "进行中"
              : "",
          },
        ];
        this.currentStep = res.data.createTime
          ? res.data.reviewRiskTime
            ? res.data.lendingTime
              ? 4
              : 3
            : 2
          : 1;
      } else {
        this.$toast(res.msg || res.message || "获取订单详情失败");
      }
      return;
    }
  },
  methods: {
    handleBack() {
      if (this.$store.getters.routerFlag == "2") {
        this.$store.commit("setRouterFlag", "1");
        localStorage.setItem("actived", 1)
        this.$router.push({
          name: "Home",
        });
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.order-details {
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  overflow-y: auto;
  background: #f4f6fa;
}
.content {
  padding: 20px 16px;
}
</style>
